export default "__VITE_ASSET__Bq$yZGvN__"